<div class="admin-table-container">
    <div class="admin-table-header">
        <p-iconfield *ngIf="showSearch" class="p-input-icon-left">
            <p-inputicon class="pi pi-search" />
            <input pInputText type="text" [(ngModel)]="searchTerm" placeholder="{{ 'adminTable.globalSearch' | transloco }}" />
        </p-iconfield>
        <div class="header-buttons">
            <p-select *ngIf="paginator && lazy" [options]="rowsPerPageOptions" [(ngModel)]="rows" [editable]="true"
                [showClear]="false" placeholder="{{ 'adminTable.rows' | transloco }}" optionLabel="label" [filter]="false"
                class="rows-per-page-select" (onChange)="onRowsChange($event)"
                style="width: 100px; margin-right: 12px;"></p-select>
            <button *ngFor="let btn of headerButtons" pButton [icon]="btn.icon ?? ''" [label]="(btn.labelKey | transloco) ?? ''"
                [class]="btn.styleClass" (click)="headerButtonClick.emit(btn.action)">
            </button>
        </div>
    </div>


    <div class="admin-table-container">
        <div class="admin-table-scroll-wrapper">
            <!-- Indicador izquierda -->
            <div class="table-scroll-indicator left" [class.hide]="!showLeftIndicator">
                <span class="arrow">&#8592;</span>
            </div>
            <!-- Indicador derecha -->
            <div class="table-scroll-indicator right" [class.hide]="!showRightIndicator">
                <span class="arrow">&#8594;</span>
            </div>
            <p-table #dt class="admin-table" [size]="'small'" [value]="filteredData"
                [paginator]="data.length > 0 && paginator" [rows]="rows ?? undefined"
                [totalRecords]="lazy ? (totalRecords ?? 0) : countRecords()" [lazy]="lazy"
                (onLazyLoad)="handleLazyLoad($event)" [sortMode]="lazy ? 'single' : 'multiple'" [customSort]="!lazy"
                (sortFunction)="!lazy && customSort($event)" [globalFilterFields]="['status']" [scrollable]="true"
                scrollHeight="flex">
                <!-- [rowsPerPageOptions]="rowsPerPageOptions" -->
                <ng-template pTemplate="header">
                    <tr>
                        <ng-content *ngFor="let col of columns">
                            <th *ngIf="col.sortable" [pSortableColumn]="col.sortable ? col.field : undefined"
                                [class.sortable]="col.sortable">
                                {{ col.header }}
                                <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                            </th>
                            <th *ngIf="!col.sortable && !col.filter" [class.sortable]="col.sortable">
                                {{ col.header }}
                            </th>
                            <th *ngIf="col.filter" (click)="openFilterPopover(col, $event)" class="pointer">
                                {{ col.header }}
                                <i class="pi" [ngClass]="col.filterValue ? 'pi-filter-fill' : 'pi-filter'"></i>
                                <p-popover #filterPopover [attr.id]="col.field">
                                    <div class="filter-popover">
                                        <ng-container *ngFor="let option of getFilteredOptions(col)">
                                            <div class="element" [class.active]="col.filterValue === option.value"
                                                (click)="filterTable(option.value, col)">
                                                <span>{{ option.label }}</span>
                                                <i class="pi pi-times close"
                                                    [class.show]="col.filterValue === option.value"></i>
                                            </div>
                                        </ng-container>
                                    </div>
                                </p-popover>
                                <!-- <p-columnFilter field="{{col.field}}" matchMode="equals" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                    <ng-template #filter let-value let-filter="filterCallback" (onChange)="filterTable(value, col)">
                                        <p-select [(ngModel)]="col.filterValue" [options]="getFilteredOptions(col)"
                                            (onChange)="filter($event.value);" placeholder="Selecciona uno"
                                            [showClear]="true" style="min-width: 12rem">
                                            <ng-template let-option #item >
                                                <p-tag>{{ option.value }}</p-tag>
                                            </ng-template>
                                        </p-select>
                                    </ng-template>
                                </p-columnFilter> -->
                            </th>
                        </ng-content>
                        <th *ngIf="actions?.length">{{ 'adminTable.actions' | transloco }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td *ngFor="let col of columns" class="content" pTooltip="{{getCellValue(row, col)}}"
                            tooltipPosition="top" tooltipStyleClass="admin-table-tooltip">
                            <ng-container [ngSwitch]="col.type">
                                <span *ngSwitchCase="'date'"
                                    [ngClass]="col.isExpiration ? getSeguroClass(getNestedValue(row, col.field)) : ''">
                                    {{ getCellValue(row, col) }}
                                </span>
                                <p-tag *ngSwitchCase="'status'" [severity]="getSeverity(col, row)">
                                    {{ getNestedValue(row, col.displayField || col.field) }}
                                </p-tag>
                                <span *ngSwitchCase="'customCss'"
                                    [ngStyle]="getNestedValue(row, col.field) == null || getNestedValue(row, col.field) === '' ? parseCss(col.css) : {}">
                                    {{ getCellValue(row, col) }}
                                </span>
                                <span *ngSwitchCase="'currency'">
                                    {{ (getNestedValue(row, col.field) ?? 0) | customCurrency }}
                                </span>
                                <span *ngSwitchDefault>
                                    {{ getNestedValue(row, col.displayField || col.field) }}
                                </span>
                            </ng-container>
                        </td>
                        <td *ngIf="actions?.length || typeof actions === 'function'" class="content">
                            <div class="action-buttons">
                                <button *ngFor="let act of getRowActions(row)" pButton [icon]="act.icon ?? ''"
                                    [class]="act.styleClass" [label]="(act.labelKey | transloco) ?? ''" [pTooltip]="act.tooltip"
                                    (click)="actionClick.emit({action: act.action ?? '', row})">
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <!-- ... -->
    </div>

    @if (data.length === 0){
    <div class="no-data">
        <p>{{ 'common.noData' | transloco }}</p>
    </div>
    }
</div>